<template>
    <div style="
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 9999;
        background-color: #EDF5F3;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 100px 20px 20px;
        display: flex;
        height: 100%;
        flex-direction: column;
        justify-content: space-between;
    ">
            <div>
                <div
                style="
                width: 100px;
                background: #01AD83;
                height: 100px;
                border-radius: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 40px;
                color: white;
                margin: 0 auto;
                "
                >&check;</div>
                <h4 class="text-center" style="
                    font-size: 26px;
                    margin-top: 20px;
                    width: 100%;
                    line-height: 34px;
                    color: #000;
                    letter-spacing: 0.31px;
                    font-weight: 500;
                    margin-bottom: 5px;
                ">{{ defaultCartLanguage.confirmation_email_heading }}</h4>
                <p class="text-center" style="width: 100%; margin-bottom: 25px">{{ defaultCartLanguage.confirmation_email_subheading }}</p>
            </div>
            <button style="margin-top: 50px; display: flex; justify-content: center; align-items: center; font-weight: bold; width: calc(100vw - 40px); height: 40px;" class="btn" @click.prevent="goHome()">{{ defaultCartLanguage.go_home }}</button>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters(['defaultCartLanguage'])
    },

    methods: {
        ...mapActions(['updateLatestOrderWithEmail', 'hideOrderEmailConfirmation']),
        goHome () {
            this.hideOrderEmailConfirmation()
            window.location.reload()
        }
    }
}
</script>
